import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import "./Landing.css";
import Spline from "@splinetool/react-spline";
import authService from "../services/authservices";

function Landing() {
  const [loginCheck, setloginCheck] = useState(false);
  const [siteDatacomes, setSiteData] = useState("");
  const [subscribePlans, setsubscribePlans] = useState([]);

  useEffect(() => {
    getSitedata();
    getAllPlans();
  }, [0]);

  const getSitedata = async () => {
    try {
      const data = await authService.getsitedata();
      if (data.status == true) {
        setSiteData(data.data);
        console.log(data, "=-=-=get site datas =-=-", data.data);
      }
    } catch (error) {}
  };

  useEffect(() => {
    let userToken = localStorage.getItem("token");
    if (userToken) {
      setloginCheck(true);
    } else {
      setloginCheck(false);
    }
  }, [0]);

  const getAllPlans = async () => {
    try {
      const data = await authService.getAllPlans();
      if (data.status == true) {
        setsubscribePlans(data.data);
        console.log(data, "=-=-=get getAllPlans =-=-", data.data);
      }
    } catch (error) {}
  };

  return (
    <>
      <Header />

      <main className="bn-main">
        {/* hero */}
        <section className="bn-hero" id="home">
          <h1 className="bn-hero-title">
            Let <span className="bn-hero-gradient">Binarge</span> Trade,{" "}
            <div className="capital_fontsize">You own the capital.</div>
            <div className="capital_fontsize"> You own the profits.</div>
          </h1>
          <p className="bn-hero-content">
            AI trading bot that runs 24/7 to maximize profits.
          </p>

          <div className="bn-hero-btn-wrap">
            {loginCheck ? (
              <Link className="bn-landing-btn" to="/home">
                Join the Community
                <span className="bn-landing-btn-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </Link>
            ) : (
              <Link className="bn-landing-btn" to="/register">
                Join the Community
                <span className="bn-landing-btn-arr">
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </Link>
            )}
          </div>

          <div className="bn-hero-animate">
            <Spline
              scene="https://prod.spline.design/x7mfluxqcknKWdbY/scene.splinecode"
              className="bn-hero-anim"
            />
            <Spline
              scene="https://prod.spline.design/yNbEm8JnABORMNnf/scene.splinecode"
              className="bn-hero-anim-mob"
            />
          </div>
          <div className="bn-logo-hide"></div>
          <div className="bn-logo-hide-mob"></div>
        </section>

        {/* light */}
        <div className="bn-light">
          {/* section one */}
          <section className="bn-grid container" id="about">
            <h3 className="bn-landing-subtitle bn-gd-mw">
              Smarter Trading, Automated Success
            </h3>
            <p className="bn-landing-content bn-gd-ct-mw">
              AI-powered automation with advanced strategies for smarter,
              faster, and more efficient trading experience.
            </p>

            <div className="row mx-0 bn-gd-row g-3">
              <div className="col-lg-7">
                <div className="bn-grid-card gd-cd-one">
                  <img
                    src={require("./img/grid-img-one.webp")}
                    alt=""
                    className="bn-gd-img"
                  />
                  <p className="bn-grid-card-content">
                    <span className="bn-gd-cd-span">
                      Multi-Exchange Integration.
                    </span>{" "}
                    Seamlessly connect with top crypto exchanges and manage all
                    your trades in one place.
                  </p>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="bn-grid-card gd-cd-two">
                  <img
                    src={require("./img/grid-img-two.gif")}
                    alt=""
                    className="gd-img-two"
                    loading="lazy"
                  />
                  <p className="bn-grid-card-content">
                    <span className="bn-gd-cd-span">AI-Powered Trading.</span>{" "}
                    AI algorithms analyze trends and execute trades precisely.
                  </p>

                  <img
                    src={require("./img/grid-ai.webp")}
                    alt=""
                    className="grid-ai-img"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className="col-lg-5">
                <div className="bn-grid-card gd-cd-two">
                  <img
                    src={require("./img/grid-img-three.webp")}
                    alt=""
                    className="bn-gd-img"
                    loading="lazy"
                  />
                  <p className="bn-grid-card-content">
                    <span className="bn-gd-cd-span">Secure & Transparent.</span>{" "}
                    Secure your assets with enterprise-grade protection and API
                    trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-7">
                <div className="bn-grid-card gd-cd-one">
                  <img
                    src={require("./img/grid-img-four.webp")}
                    alt=""
                    className="bn-gd-img"
                    loading="lazy"
                  />
                  <p className="bn-grid-card-content">
                    <span className="bn-gd-cd-span">Custom Strategy.</span> Set
                    your own trading rules and let Binarge execute with
                    precision.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* section two */}
          <section className="bn-ef " id="features">
            <div className="container bn-ef-contents">
              <h3 className="bn-landing-subtitle bn-ef-title">
                Effortless Trading for Limitless Living
              </h3>
              <p className="bn-landing-content text-center mt-3">
                AI-powered tools that trade for you, effortlessly.
              </p>
            </div>

            <div className="ef-img-wrap">
              <img
                src={require("./img/ef-img.webp")}
                alt=""
                className="w-100 ef-img"
                loading="lazy"
              />
            </div>

            <div className="container bn-ef-card-wrap">
              <div className="row mx-0 bn-ef-row g-4 g-sm-5 g-lg-3">
                <div className="col-lg-4 col-md-6">
                  <div className="bn-ef-cards">
                    <img src={require("./img/ef-cd-icon-one.webp")} alt="" />
                    <h5 className="bn-ef-cd-title">AI Powered Strategies</h5>
                    <p className="bn-ef-cd-content">
                      Automate trades with intelligent algorithms for maximum
                      efficiency.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="bn-ef-cards">
                    <img src={require("./img/ef-cd-icon-two.webp")} alt="" />
                    <h5 className="bn-ef-cd-title">
                      Real Time Market Analysis
                    </h5>
                    <p className="bn-ef-cd-content">
                      Stay ahead with instant data insights and trend
                      predictions.
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6">
                  <div className="bn-ef-cards">
                    <img src={require("./img/ef-cd-icon-three.webp")} alt="" />
                    <h5 className="bn-ef-cd-title">Lightning Fast Execution</h5>
                    <p className="bn-ef-cd-content">
                      Execute trades at the perfect moment without delays.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* steps */}
        <section className="bn-step">
          <div className="container" id="howworks">
            <h3 className="bn-landing-subtitle bn-st-title">
              Simple Steps to Smarter Trading
            </h3>
            <p className="bn-landing-content bn-st-content">
              Get started in minutes and let Binarge handle the trades for you.
            </p>

            <div className="row mx-0 bn-st-row gy-sm-5 g-4 gx-xl-5">
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-one.webp")} alt="" />
                  </div>

                  <h5>Create Account</h5>
                  <p>Create your account and access Binarge.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-two.webp")} alt="" />
                  </div>

                  <h5>Deposit Amount</h5>
                  <p>Securely deposit funds to start trading.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-three.webp")} alt="" />
                  </div>

                  <h5>Plan Upgrade</h5>
                  <p>Choose a plan that fits your trading goals.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-four.webp")} alt="" />
                  </div>

                  <h5>Enable Exchange</h5>
                  <p>Securely connect your crypto exchange.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-five.webp")} alt="" />
                  </div>

                  <h5>Activate Bot</h5>
                  <p>Let Binarge's AI bot trade for you 24/7.</p>
                </div>
              </div>
              <div className="col-lg-4 col-sm-6">
                <div className="bn-st-card">
                  <div className="bn-st-card-img">
                    <img src={require("./img/st-img-six.webp")} alt="" />
                  </div>

                  <h5>Withdraw Profits</h5>
                  <p>Withdraw your earnings anytime, hassle free.</p>
                </div>
              </div>
            </div>
          </div>

          {/* plan */}
          <div className="container bn-pl-container">
            <div className="bn-plan">
              <h4 className="bn-ft-title text-center">
                Pick Your Plan, Trade Smarter
              </h4>
              <p className="bn-ft-content text-center">
                Flexible subscription plans to power your crypto journey with
                Binarge.
              </p>

              <div className="row mx-0 g-lg-5 g-4 bn-plan-row">
                {subscribePlans.length > 0 ? (
                  <>
                    <div className="col-xl-5 col-md-6 bn-pn-col">
                      <div className="bn-pln-col">
                        <div className="bn-plan-card-outer">
                          <div className="bn-plan-card-inner">
                            <div className="text-center">
                              <img
                                src={require("../assests/freemium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-freemium">
                              {subscribePlans[0].subscriptionName}
                            </h3>

                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                Free <span></span>
                              </h6>

                              <p className="bn-pln-rgt-content">
                                Free for {subscribePlans[0].subdays} Days
                              </p>
                            </div>

                            <div className="bn-pln-details-wrap">
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-fr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-freemium">
                                    Strategies:
                                  </span>{" "}
                                  {subscribePlans[0].Strategies}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-fr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-freemium">
                                    Exchanges:
                                  </span>
                                  {subscribePlans[0].Exchanges}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-fr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-freemium">
                                    Profit Split:
                                  </span>{" "}
                                  {subscribePlans[0].SecondDistribution.user}
                                  (Users) +{" "}
                                  {subscribePlans[0].SecondDistribution.admin}
                                  (Admins)
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-fr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-freemium">
                                    Minimum fuel balance required:
                                  </span>{" "}
                                  {subscribePlans[0].min_fuel}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bn-plan-blue"></div>
                        <div className="bn-plan-orange"></div>
                      </div>
                    </div>

                    <div className="col-xl-5 col-md-6 bn-pn-col">
                      <div className="bn-pln-col">
                        <div className="bn-plan-card-outer">
                          <div className="bn-plan-card-inner">
                            <div className="text-center">
                              <img
                                src={require("../assests/premium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-premium">
                              {subscribePlans[1].subscriptionName}
                            </h3>

                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[1].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[1].subscriptionCurrency}/Month
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>

                            <div className="bn-pln-details-wrap">
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    Strategies:
                                  </span>{" "}
                                  {subscribePlans[1].Strategies}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">Exchanges:</span>
                                  {subscribePlans[1].Exchanges}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    Profit Split:
                                  </span>{" "}
                                  {subscribePlans[1].SecondDistribution.user}
                                  (Users) +{" "}
                                  {subscribePlans[1].SecondDistribution.admin}
                                  (Admin)
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    Referral one time reward (
                                    {subscribePlans[1].subscriptionCurrency}):
                                  </span>{" "}
                                  {subscribePlans[1].referral_first}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    Referral reward for recurring payment (%):
                                  </span>{" "}
                                  {subscribePlans[1].referral_percentage}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-pr">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-premium">
                                    Minimum fuel balance required:
                                  </span>{" "}
                                  {subscribePlans[1].min_fuel}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bn-plan-blue"></div>
                        <div className="bn-plan-orange"></div>
                      </div>
                    </div>

                    <div className="col-xl-5 col-md-6 bn-pn-col">
                      <div className="bn-pln-col">
                        <div className="bn-plan-card-outer">
                          <div className="bn-plan-card-inner">
                            <div className="text-center">
                              <img
                                src={require("../assests/promium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-promium">
                              {subscribePlans[2].subscriptionName}
                            </h3>

                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[2].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[2].subscriptionCurrency}/Month
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>

                            <div className="bn-pln-details-wrap">
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Strategies:
                                  </span>{" "}
                                  {subscribePlans[2].Strategies}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">Exchanges:</span>
                                  {subscribePlans[2].Exchanges}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Profit Split:
                                  </span>{" "}
                                  {subscribePlans[2].SecondDistribution.user}
                                  (Users) +{" "}
                                  {subscribePlans[2].SecondDistribution.admin}
                                  (Admin)
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Referral one time reward (
                                    {subscribePlans[2].subscriptionCurrency}):
                                  </span>{" "}
                                  {subscribePlans[2].referral_first}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Referral reward for recurring payment (%):
                                  </span>{" "}
                                  {subscribePlans[2].referral_percentage}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Minimum fuel balance required:
                                  </span>{" "}
                                  {subscribePlans[2].min_fuel}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bn-plan-blue"></div>
                        <div className="bn-plan-orange"></div>
                      </div>
                    </div>

                    <div className="col-xl-5 col-md-6 bn-pn-col">
                      <div className="bn-pln-col">
                        <div className="bn-plan-card-outer">
                          <div className="bn-plan-card-inner">
                            <div className="text-center">
                              <img
                                src={require("../assests/promium.webp")}
                                alt="freemium"
                                className="bn-plan-card-img"
                              />
                            </div>
                            <h3 className="bn-pln-cd-title bn-promium">
                              {subscribePlans[3].subscriptionName}
                            </h3>

                            <div className="bn-pln-subtitle-wrap">
                              <h6 className="bn-pln-lft-title">
                                {parseFloat(
                                  subscribePlans[3].subscriptionAmount
                                ).toFixed(2)}{" "}
                                <span>
                                  {subscribePlans[3].subscriptionCurrency}/Month
                                </span>
                              </h6>

                              {/* <p className="bn-pln-rgt-content">Free for 7 month</p> */}
                            </div>

                            <div className="bn-pln-details-wrap">
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Strategies:
                                  </span>{" "}
                                  {subscribePlans[3].Strategies}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">Exchanges:</span>
                                  {subscribePlans[3].Exchanges}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Profit Split:
                                  </span>{" "}
                                  {subscribePlans[3].SecondDistribution.user}
                                  (Users) +{" "}
                                  {subscribePlans[3].SecondDistribution.admin}
                                  (Admin)
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Referral one time reward (
                                    {subscribePlans[3].subscriptionCurrency}):
                                  </span>{" "}
                                  {subscribePlans[3].referral_first}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Referral reward for recurring payment (%):
                                  </span>{" "}
                                  {subscribePlans[3].referral_percentage}
                                </p>
                              </div>
                              <div className="bn-pln-dt-flx">
                                <span className="bn-plan-check bn-plan-promium">
                                  <i className="fa-solid fa-check"></i>
                                </span>

                                <p className="bn-plan-details-content">
                                  <span className="bn-promium">
                                    Minimum fuel balance required:
                                  </span>{" "}
                                  {subscribePlans[3].min_fuel}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="bn-plan-blue"></div>
                        <div className="bn-plan-orange"></div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          {/* future */}
          <section className="container ">
            <div className="bn-ft-outer">
              <div className="row mx-0 bn-ft-row">
                <div className="col-lg-6">
                  <h4 className="bn-ft-title">
                    Step Into the Future of Crypto Trading
                  </h4>
                  <p className="bn-ft-content">
                    Leverage blockchain security and AI automation to trade
                    smarter, faster, and more efficiently. Join Binarge and
                    experience next-level trading.
                  </p>
                  <div className="bn-ft-btn-wrap">
                    {loginCheck ? (
                      <Link className="bn-landing-btn" to="/home">
                        Join Binarge Now
                        <span className="bn-landing-btn-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    ) : (
                      <Link className="bn-landing-btn" to="/register">
                        Join Binarge Now
                        <span className="bn-landing-btn-arr">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    )}
                  </div>
                </div>
                <div className="col-lg-6 ft-rgt-col">
                  <div className="bn-ft-rgt">
                    <Spline
                      scene="https://prod.spline.design/3EqOsGfaO9MxkwVc/scene.splinecode"
                      className="bn-ft-animate"
                    />
                    <Spline
                      scene="https://prod.spline.design/3EqOsGfaO9MxkwVc/scene.splinecode"
                      className="bn-ft-animate-mob"
                    />

                    <div className="bn-ft-an-bg"></div>
                    <div className="bn-ft-an-bg-mob"></div>
                  </div>
                </div>
              </div>

              {/* <img
                  src={require("./img/ft-left.webp")}
                  alt=""
                  className="ft-lft"
                />
                <img
                  src={require("./img/ft-right.webp")}
                  alt=""
                  className="ft-rgt"
                /> */}
            </div>
          </section>
        </section>

        {/* footer  */}
        <footer className="bn-footer">
          <div className="container">
            <section className="row mx-0 bn-footer-row g-4 g-lg-1">
              <div className="col-lg-4 col-sm-6 col-12">
                <div>
                  <img
                    src={require("./img/footer-logo.webp")}
                    alt=""
                    className="bn-footer-logo"
                  />
                  <p className="bn-footer-logo-content">
                    AI-powered crypto trading bot with blockchain security for
                    seamless and automated trading.
                  </p>
                </div>
              </div>
              <div className="col-lg-2 col-sm-3 col-6">
                <h6 className="bn-footer-link-title">Explore</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                    <Link to="/" className="bn-footer-links">
                      Newbies
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Knowledge Base
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Strategies
                    </Link>
                  </li> */}
                  <li>
                    <Link to="/termscondition" className="bn-footer-links">
                      Terms and Service
                    </Link>
                  </li>
                  <li>
                    <Link to="/privacypolicy" className="bn-footer-links">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-3 col-6">
                <h6 className="bn-footer-link-title">Quick Links</h6>
                <ul className="bn-footer-lists">
                  <li>
                    {/* <Link to="/" className="bn-footer-links"> */}
                    <a href="#home" className="bn-footer-links">
                      Home
                    </a>
                  </li>
                  <li>
                    <a href="#about" className="bn-footer-links">
                      About
                    </a>
                  </li>
                  <li>
                    <a href="#features" className="bn-footer-links">
                      Features
                    </a>
                  </li>
                  <li>
                    <a href="#howworks" className="bn-footer-links">
                      How It Works
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Support</h6>
                <ul className="bn-footer-lists">
                  {/* <li>
                    <Link to="/" className="bn-footer-links">
                      Terms & Conditions
                    </Link>
                  </li>
                  <li>
                    <Link to="/" className="bn-footer-links">
                      Privacy Policy
                    </Link>
                  </li> */}
                  <li>
                    <Link
                      to={loginCheck ? "/support" : "/login"}
                      className="bn-footer-links"
                    >
                      Help Center
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="col-lg-2 col-sm-6 col-6">
                <h6 className="bn-footer-link-title">Social</h6>
                <ul className="bn-footer-icon-wrap">
                  <li>
                    <a target="_blank" href={siteDatacomes.instagram}>
                      <img src={require("./img/instagram.webp")} alt="" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href={siteDatacomes.twitter}>
                      <img src={require("./img/x.webp")} alt="" />
                    </a>
                  </li>
                  <li>
                    <a target="_blank" href={siteDatacomes.telegram}>
                      <img src={require("./img/telegram.webp")} alt="" />
                    </a>
                  </li>
                </ul>
              </div>
            </section>

            {/* <section className="bn-disclaimer">
              <h3 className="bn-ds-title">Disclaimer</h3>
              <ul className="bn-ds-lists">
                <li>
                  There are substantial risks in investing in a Crypto
                  Portfolio. Persons interested in investing in a Crypto
                  Portfolio should carefully note the following:
                </li>
                <li>
                  Binarge is not a broker-dealer, exchange, custodian, or wallet
                  provider, and is not intended for frequent trading activity.
                  Investing in digital assets is highly speculative and volatile
                  and Binarge is only suitable for investors who are willing to
                  bear the risk of loss and experience sharp drawdowns.
                </li>
                <li>
                  Binarge do not offer tax, financial, accounting or legal
                  advice. Carefully consider the risk factors, investment
                  objectives, fees, expenses, and other information associated
                  with before making an investment decision. All investments are
                  speculative, may be illiquid and involve a high degree of
                  risk, uncertainty, and there is risk of the complete loss of
                  the investment. There is no guarantee that any specific
                  outcome will be achieved. Since each individual's situation is
                  unique, a qualified professional should always be consulted
                  before making any financial decisions.
                </li>
                <li>
                  The information provided within this website within it is not
                  intended as an offer to sell, or the solicitation of an offer
                  to buy/invest in any digital assets & funds. Such offerings
                  may only be made by prospectus and offering documents.
                </li>
                <li>
                  Binarge would like to remind you that the data contained in
                  this website is not necessarily real-time nor accurate. All
                  cryptocurrencies, baskets, ETF, and fund prices are not
                  provided by us but rather by market makers, and so prices may
                  not be accurate and may differ from the actual market price,
                  meaning prices are indicative and not appropriate for trading
                  purposes. Images, charts & stats on this page include
                  illustrations of user experiences intended to demonstrate the
                  format of Binarge's interface. These images do not reflect
                  actual or performance of our recommendations. Past performance
                  is not a guarantee of future results.
                </li>
                <li>
                  For more complete disclosures and information about how
                  Binarge works, please visit our Terms of Service and Help
                  Center.
                </li>
              </ul>
            </section> */}
          </div>

          <section className="bn-copyrights">
            <p className="bn-copyrights-txt">
              &copy;2025 Binarge All Rights Reserved.
            </p>
          </section>
        </footer>
      </main>
    </>
  );
}

export default Landing;
